import {FULFILLED} from 'redux-promise-middleware';

import {BLOG, CART, CATEGORY, CHECKOUT, CUSTOMER, PRODUCT, QUOTE_ITEM} from 'constants/actions';

import {call, all, take} from 'redux-saga/effects';
import {getIsCustomerLoaded} from 'selectors/customer/customer';
import {getIsPaymentMethodFulfilled} from 'selectors/checkout/checkout';
import {getPaymentsFulfilled} from 'selectors/payments/payments';
import {waitForFulfilled} from 'libs/utils/utils';
import {getIsProductFulfilled, getIsReviewsItemsFulfilled} from 'selectors/product/product';
import {getIsCategoryFulfilled, getIsCategoryItemsFulfilled} from 'selectors/category/category';
import {getCustomerSaga} from 'sagas/customer/customer';
import {isBlogPostFulfilled} from 'selectors/blog/blog';
import {isAddToCartCleared} from 'selectors/cartAdd/cartAdd';
import {isOrderDataFulfilled} from 'pages/checkout/store/selectors/orderData/orderData';
import {isOrderReviewFulfilled} from 'selectors/checkout/orderReview/orderReview';
import {clearCartAdd} from 'actions/cart/cart';

/**
 * Wait for customer fulfilled
 */
export function* waitForCustomer() {
    yield call(waitForFulfilled, getIsCustomerLoaded, `${CUSTOMER.GET_CUSTOMER_DATA}_${FULFILLED}`);
}

/**
 * Wait for order data fulfilled
 */
export function* waitForOrderData() {
    yield call(waitForFulfilled, isOrderDataFulfilled, `${CHECKOUT.SAVE_ORDER}_${FULFILLED}`);
}

/**
 * Wait for order review fulfilled
 */
export function* waitForOrderReview() {
    yield call(
        waitForFulfilled,
        isOrderReviewFulfilled,
        `${CHECKOUT.GET_ORDER_REVIEW_ITEMS}_${FULFILLED}`,
    );
}

/**
 * Wait for product fulfilled
 */
export function* waitForProduct() {
    yield call(waitForFulfilled, getIsProductFulfilled, `${PRODUCT.GET_PRODUCT}_${FULFILLED}`);
}

/**
 * Wait for product reviews fulfilled
 */
export function* waitForProductReviews() {
    yield call(
        waitForFulfilled,
        getIsReviewsItemsFulfilled,
        `${PRODUCT.FETCH_REVIEWS}_${FULFILLED}`,
    );
}

/**
 * Wait for cart ready.
 */
export function* waitForCart() {
    yield all([
        take(`${QUOTE_ITEM.GET_ITEMS}_${FULFILLED}`),
        call(waitForFulfilled, getPaymentsFulfilled, `${CART.GET_PAYMENT_BUTTONS}_${FULFILLED}`),
    ]);
}

/**
 * Wait for cart ready.
 */
export function* waitForCategory() {
    yield all([
        call(waitForFulfilled, getIsCategoryFulfilled, `${CATEGORY.GET_CATEGORY}_${FULFILLED}`),
        call(
            waitForFulfilled,
            getIsCategoryItemsFulfilled,
            `${CATEGORY.GET_CATEGORY_ITEMS}_${FULFILLED}`,
        ),
    ]);
}

/**
 * Wait for payment methods ready.
 */
export function* waitForPaymentMethods() {
    yield call(waitForFulfilled, getIsPaymentMethodFulfilled, `GET_PAYMENT_METHODS_FULFILLED`);
}

/**
 * Wait for blog post.
 */
export function* waitForBlogPost() {
    yield call(waitForFulfilled, isBlogPostFulfilled, `${BLOG.GET_ONE_POST}_${FULFILLED}`);
}

/**
 * Wait for success page data ready.
 */
export function* waitForSuccessPage() {
    yield call(getCustomerSaga);
    yield all([call(waitForCustomer), call(waitForOrderReview), call(waitForPaymentMethods)]);
}

/**
 * Wait for add to cart is cleared.
 */
export function* waitForAddToCartCleared() {
    yield call(waitForFulfilled, isAddToCartCleared, `${clearCartAdd}`);
}
